import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import { useState } from "react";
import { useEffect } from "react";
import axios from "axios";
import "./Vendor.css";
import { Link } from "react-router-dom";

export const Vendor = () => {
  const [brands, setBrands] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    setLoading(true);
    axios
      .get("/page-section/public/shows?sectionType=partner")
      .then((res) => {
        const brandData = res.data.data || [];
        setBrands(brandData);
      })
      .catch((err) => console.log(err))
      .finally(() => setLoading(false));
  };

  return (
    <div className="container-fluid py-5">
      <div className="row px-xl-5">
        <div className="col">
          <h2 className="section-title position-relative text-uppercase mb-4 text-2xl font-bold">
            <span className="bg-secondary pr-3">Đối tác</span>
          </h2>
          {loading ? (
            <div className="text-center py-4">
              <div className="spinner-border text-primary" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          ) : (
            <Swiper
              modules={[Autoplay]}
              slidesPerView={2}
              spaceBetween={29}
              loop={true}
              autoplay={{ delay: 2000, disableOnInteraction: false }}
              breakpoints={{
                576: { slidesPerView: 3 },
                768: { slidesPerView: 4 },
                992: { slidesPerView: 5 },
                1200: { slidesPerView: 6 },
              }}
              className="w-full"
            >
              {brands?.map((item, index) => (
                <SwiperSlide
                  key={index}
                  className="brand-slide bg-light d-flex justify-content-center align-items-center"
                >
                  <div className="brand-container">
                    <Link to={item?.content[0]?.link || "#"} target="_blank">
                      <img
                        src={item?.content[0]?.imageUrl}
                        alt={item?.content[0]?.title || `Đối tác ${index + 1}`}
                        className="brand-image"
                        title={item?.content[0]?.title}
                      />
                    </Link>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          )}
        </div>
      </div>
    </div>
  );
};
